export const en = {
  schoolSubtitle: 'Access through the Agenda1 app',
  scanQrCode: 'Point your phone camera at the QR Code',
  or: 'or',
  downloadApp: 'Download the app from official stores',
  appStoreBadgeUrl: 'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83',
  appStoreBadgeAlt: 'Download on the App Store',
  playStoreBadgeUrl: 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png',
  playStoreBadgeAlt: 'Get it on Google Play',
  openAppStore: 'Open on App Store',
  openPlayStore: 'Open on Google Play',
  printQrCode: 'Print QR Code',
  schoolCode: 'School code',
  scanInstruction: 'Point your phone camera at the QR Code above',
  accessUrl: 'or access',
  needHelp: 'Need help? Contact support',
  support: 'support@agenda1.app',
  copyright: `© ${new Date().getFullYear()} Agenda1. All rights reserved.`,
  // Mobile 2-step flow
  step1Title: 'Download the App',
  step1Description: 'If you don\'t have it yet, download Agenda1',
  step2Title: 'Open the School',
  step2Description: 'Tap to open the school in the app',
  openSchoolButton: 'Open School in App',
  alreadyHaveApp: 'Already have the app?'
}

export type TranslationKeys = {
  schoolSubtitle: string
  scanQrCode: string
  or: string
  downloadApp: string
  appStoreBadgeUrl: string
  appStoreBadgeAlt: string
  playStoreBadgeUrl: string
  playStoreBadgeAlt: string
  openAppStore: string
  openPlayStore: string
  printQrCode: string
  schoolCode: string
  scanInstruction: string
  accessUrl: string
  needHelp: string
  support: string
  copyright: string
  // Mobile 2-step flow
  step1Title: string
  step1Description: string
  step2Title: string
  step2Description: string
  openSchoolButton: string
  alreadyHaveApp: string
}
